import { GetClientResponse } from './api'

export interface Client extends GetClientResponse {}

export const docTypes = [
  'bank_card',
  'driver_license_1999_paper_back',
  'driver_license_1999_paper_front',
  'driver_license_1999_plastic_back',
  'driver_license_1999_plastic_front',
  'driver_license_2011_back',
  'traffic_accident_notice_front',
  'driver_license_2011_front',
  'driver_license_2014_back',
  'driver_license_japan',
  'global_passport',
  'inn_organisation',
  'inn_person',
  'insurance_plastic',
  'kgz_passport_main',
  'kgz_passport_plastic_blue',
  'kgz_passport_plastic_red',
  'migration_card',
  'military_id',
  'mts_acts',
  'mts_rfa',
  'ndfl2',
  'not_document',
  'ogrn',
  'ogrnip',
  'other',
  'passport_blank_page',
  'passport_registration_handwritten',
  'passport_children',
  'passport_last_rf',
  'passport_main',
  'passport_main_handwritten',
  'passport_marriage',
  'passport_military',
  'passport_previous_docs',
  'passport_registration',
  'passport_zero_page',
  'pts_back',
  'pts_front',
  'registration_certificate',
  'rus_work_patent',
  'snils_back',
  'snils_front',
  'tjk_passport_main',
  'uzb_passport_main',
  'vehicle_registration_certificate_back',
  'vehicle_registration_certificate_front',
]
